
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PromoHero from './components/PromoHero';
import FlashDeals from './components/FlashDeals';
import BundleDeals from './components/BundleDeals';
import SeasonalPromos from './components/SeasonalPromos';
import PromoTestimonials from './components/PromoTestimonials';
import PromoClaimForm from './components/PromoClaimForm';
import UrgencyBanner from './components/UrgencyBanner';

export default function PromoDealsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <main>
        <PromoHero />
        <FlashDeals />
        <BundleDeals />
        <SeasonalPromos />
        <PromoTestimonials />
        <PromoClaimForm />
        <UrgencyBanner />
      </main>
      <Footer />
    </div>
  );
}
